import { CONTEXT_TYPES, ORDER_TYPES } from '@nandosaus/constants';
import { types } from 'mobx-state-tree';

import { DineInFulfilment, PickUpFulfilment, DeliveryFulfilment } from './fulfilments';

// eslint-disable-next-line prefer-destructuring
const qrFlow = process.env.qrFlow;
const showAllOrderOptionsForRestaurants = qrFlow?.showAllOrderOptionsForRestaurants || [];

const getDefaultQrOrderType = ({ orderType, shouldShowAllOrderOptions }) => {
  if (orderType) {
    return orderType;
  }

  if (shouldShowAllOrderOptions) {
    return ORDER_TYPES.PICK_UP;
  }

  return ORDER_TYPES.DINE_IN;
};

export const PresetContext = types
  .model({
    type: types.literal(CONTEXT_TYPES.PRESET),
    availableOrderTypes: types.optional(
      types.array(types.enumeration([ORDER_TYPES.DINE_IN, ORDER_TYPES.PICK_UP, ORDER_TYPES.DELIVERY])),
      []
    ),
  })
  .actions(self => {
    return {
      init({ orderType, showAllOrderTypes, restaurantId, tableNumber }) {
        const shouldShowAllOrderOptions =
          showAllOrderOptionsForRestaurants.some(item => item === restaurantId) || showAllOrderTypes;

        const defaultOrderType = getDefaultQrOrderType({
          orderType,
          shouldShowAllOrderOptions,
        });

        self.availableOrderTypes = shouldShowAllOrderOptions
          ? [ORDER_TYPES.PICK_UP, ORDER_TYPES.DINE_IN, ORDER_TYPES.DELIVERY]
          : [defaultOrderType];

        if (defaultOrderType === ORDER_TYPES.DELIVERY) {
          const fulfilment = DeliveryFulfilment.create({ type: defaultOrderType });
          return { fulfilment };
        }

        if (defaultOrderType === ORDER_TYPES.PICK_UP) {
          const fulfilment = PickUpFulfilment.create({ type: defaultOrderType, restaurantId });
          return { fulfilment };
        }

        const fulfilment = DineInFulfilment.create({
          type: ORDER_TYPES.DINE_IN,
          restaurantId,
          tableNumber,
        });

        return { fulfilment };
      },
    };
  });
